;(function () {
    'use strict';
    ready(function()
    {
        if (typeof Highcharts === 'undefined') {
            return;
        }
        Highcharts.setOptions({
            lang: {
                thousandsSep: ",",
                numericSymbols: null
            },
            chart: {
                backgroundColor: "rgba(255, 255, 255, 1)",
                height: 400,
                style: {
                    fontFamily: 'Public Sans'
                }
            },
            exporting: {
                buttons: {
                    contextButton: {
                        symbolStroke: "black",
                        theme: {
                            fill: "rgba(255, 255, 255, 0)"
                        }
                    }
                }
            },
            credits: {
                enabled: false
            },
            tooltip: {
                useHTML: true,
                backgroundColor: "#ffffff",
                padding: 1
            },
            title: {
                paddingRight: 48,
                margin: 40,
                align: "left",
                useHTML: true,
                style: {
                    fontSize: "16px",
                    color: "#000000"
                }
            },
            subtitle: {
                align: "left",
                paddingRight: 48,
                useHTML: true,
                style: {
                    fontSize: "16px",
                    lineHeight: "1.5",
                    color: "#000000"
                }
            },
            xAxis: {
                labels: {
                    zIndex: 0
                }
            },
            yAxis: {
                labels: {
                    zIndex: 0
                }
            },
            colors: ["#3e2c56", "#13d0ca", "#a3d55f", "#4e748b", "#c08bbf", "#3cb4e7", "#F79552", "#E5E9EA", "#A6BBC9", "#C0B8B0", "#7A6E67", "#04874C"]
            // colors: ["#6d276a", "#00a88f", "#c3d941", "#d7d0cd", "#21428f", "#009cd6", "#8d857e", "#7b8fba", "#6e8021", "#467ea4", "#387078", "#a88c29"]
        });
    });
}());
